export default "__VITE_ASSET__Y_qex4o0__"